import { render, staticRenderFns } from "./PersonRecord.vue?vue&type=template&id=1325d5e8&"
import script from "./PersonRecord.vue?vue&type=script&lang=js&"
export * from "./PersonRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports